import { getDollarRangeCompactLabel } from '.';

/**
 * Get a label appropriate for displaying an estimated loss range, like `$1K - $5K`, with some
 * logic to handle edge cases.
 * @param range the number range to get the label for
 * @returns a string, or null if nothing should be rendered
 */
export const getEstimatedLossLabel = (range: NumberRange): Maybe<string> => {
    const { min, max } = range;

    let label = '$0';

    if (min > 0 && max >= 1) {
        // If min is positive and max is one or more, return a label for the range as-is
        label = getDollarRangeCompactLabel({
            max,
            min,
        });
    } else if (min <= 0 && max >= 1) {
        // If min is zero or negative and max is one or more, use 0 as the min for the range
        label = getDollarRangeCompactLabel({
            max,
            min: 0,
        });
    } else if (max > 0 && max < 1) {
        // If max is between 0 and 1, return '<$1'
        label = '<$1';
    }

    if (max <= 0) {
        // If the max is negative, return null to indicate that nothing should be rendered
        return null;
    }

    return label;
};
